import { FC } from 'react';
import { Box, Chip, styled, Typography, useTheme } from '@mui/material';
import { Collections } from '@mui/icons-material';

import { HotelMediaDTO } from '@bandido/shared/dtos';

const MainImageContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  flex: 1,
  '> img': {
    width: '100%',
    aspectRatio: '1 / 1',
    objectFit: 'cover',
    borderRadius: theme.spacing(2),
  }
}));

const SideImageWrapper = styled('div')(() => ({
  position: 'relative'
}));

const SideImage = styled('img')<{ fade?: boolean }>(({ theme, fade }) => ({
  objectFit: 'cover',
  width: '100%',
  aspectRatio: '1 / 1',
  objectPosition: 'center',
  borderRadius: theme.spacing(2),
  opacity: fade ? 0.3 : 1
}));


interface Props {
  images: HotelMediaDTO[]
}

export const HotelFaresViewImageExplorer: FC<Props> = ({ images }) => {
  const theme = useTheme();

  return images.length >0 ?(
    <Box display="flex" gap={2} alignItems="stretch" >
      <MainImageContainer>
        <img
          src={images[0].url}
          alt="Main"
        />
      </MainImageContainer>
      <Box flex={1} display="flex" gap={2} alignItems="stretch">
        <Box display="flex" flexDirection="column" justifyContent="space-between" flex={1}>
          <SideImageWrapper>
            {(images && images[1] && images[1].url) &&   <SideImage width="100%" src={images[1].url} alt="Side 1" />}
          </SideImageWrapper>
          <SideImageWrapper>
            {(images && images[2] && images[2].url) && <SideImage width="100%" src={images[2].url} alt="Side 1" />}
          </SideImageWrapper>
        </Box>
        <Box display="flex" flexDirection="column" justifyContent="space-between" flex={1}>
          <SideImageWrapper>
            {(images && images[3] && images[3].url) && <SideImage width="100%" src={images[3].url} alt="Side 1" />}
          </SideImageWrapper>
          <SideImageWrapper>
            {(images && images[3] && images[3].url) &&  <SideImage width="100%" fade src={images[3].url} alt="Side 1" />}
            <Chip
              sx={{
                position: 'absolute',
                width: '90px',
                height: '36px',
                top: 'calc(50% - 18px)',
                left: 'calc(50% - 45px)',
                background: 'rgba(0, 0, 0, 0.56)',
              }}
              label={(
                <Box display="flex" alignItems="center">
                  <Collections
                    sx={{ color: theme.palette.paper.light }}
                  />
                  <Typography
                    variant='body2'
                    sx={{ color: theme.palette.paper.light }}
                  >
                    + {images.length - 4}
                  </Typography>
                </Box>
              )} />
          </SideImageWrapper>
        </Box>
      </Box>
    </Box>

  ):null;
};
